<template>
  <div class="page-wrapper">
    <commonHeader heading="学习力指标调研" subtitle="创建调研问卷">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <v-card>
      <div class="page-content">
        <div class="ques-header">
          <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step step="1">
                创建问卷
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2">
                发布问卷
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>
        <div class="ques-info" :style="{ display: isMobile.isMobile ? 'block' : 'flex'}">
          <div class="left-content">
            <div class="select-title">题型选择</div>
            <div class="select-btn">
              <div class="row" @click="selectDialogOpen('radio')">单选</div>
            </div>
            <div class="select-btn" style="margin: 0 5px;">
              <div class="row" @click="selectDialogOpen('checkbox')">多选</div>
            </div>
            <div class="select-btn">
              <div class="row" @click="selectDialogOpen('question')">问答</div>
            </div>
          </div>
          <div class="right-content">
            <div class="form-flex">
              <div class="form-header">
                问卷名称
              </div>
              <div class="form-content">
                <v-text-field filled v-model="form.name" color="#4caf50" :rules="[(v) => !!v || '指标名称不能为空']"></v-text-field>
              </div>
            </div>
            <div class="form-flex">
              <div class="form-header">
                问卷封面
              </div>
              <div class="form-content">
                <v-file-input
                  truncate-length="15"
                ></v-file-input>
              </div>
            </div>
            <div class="form-flex">
              <div class="form-header">
                问卷简介
              </div>
              <div class="form-content">
                <v-textarea filled v-model="form.value2"></v-textarea>
              </div>
            </div>
            <div class="test-paper">
                <div class="paper-title">组卷</div>
                <div class="paper-content">
                  <div class="paper-row" v-for="(item, index) in testpaperList" :key="index">
                    <div class="first-operate" :style="{ display: isMobile.isMobile ? 'block' : 'flex'}">
                      <div class="big-title"></div>
                      <div class="checkbox-title">
                        <v-checkbox
                          style="margin-right: 10px;"
                          v-model="item.isDown"
                          label="下拉选项"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="item.isMust"
                          label="必填"
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="icon">
                        <span class="mdi mdi-pencil" @click="editTestpaper(item,index)"></span>
                        <span class="mdi mdi-content-copy"></span>
                        <span class="mdi mdi-arrow-up-bold-circle-outline" v-if="index !== 0" @click="upTestpaper(index)"></span>
                        <span class="mdi mdi-arrow-down-bold-circle-outline" v-if="index !== testpaperList.length - 1" @click="downTestpaper(index)"></span>
                        <span class="mdi mdi-trash-can-outline" @click="delTestpaper(index)"></span>
                      </div>
                    </div>
                    <div class="second-title">
                      {{ index + 1 }}，{{ item.name }}
                    </div>
                    <div class="three-content">
                      <div class="radio-select" v-if="item.type == 'radio'">
                        <v-radio-group
                          hide-details
                          column
                        >
                          <v-radio
                            v-for="(t, i) in item.option" :key="i"
                            :label="t.label"
                            :value="t.value"
                            disabled
                          ></v-radio>
                        </v-radio-group>
                      </div>
                      <div class="checkbox-select" v-if="item.type == 'checkbox'">
                        <v-checkbox
                          v-for="(t, i) in item.option" :key="i"
                          :label="t.label"
                          hide-details
                          disabled
                        ></v-checkbox>
                      </div>
                      <div class="quest-select" v-if="item.type == 'question'">
                        请输入内容
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page-btn">
                  <v-btn elevation="0" :ripple="false" height="35" color="success"
                  class="font-weight-normal text-capitalize btn-ls py-3 px-6" >发布问卷</v-btn>
                </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- 单选多选 -->
    <v-dialog v-model="selectDialog" max-width="800px">
      <v-card class="card-shadow">
        <v-card-title>
          <span class="text-h5">{{ selectDialogTitle }}</span>
        </v-card-title>
        <v-card-text class="topic-form">
          <div class="topic-title">
            <div class="idnex">题干</div>
            <div class="text">这里写题目描述</div>
          </div>
          <div class="topic-describe">
            <v-textarea outlined hide-details
             v-model="selectTopicFrom.name"></v-textarea>
          </div>
          <div class="topic-title" v-if="selectTopicFrom.type !== 'question'">
            <div class="idnex">选项</div>
            <div class="text">{{selectDialogTitle}}的选择范围从2到20</div>
            <div class="icon" @click="addSelect()">
              添加选项
            </div>
          </div>
          <div class="topic-select" v-if="selectTopicFrom.type !== 'question'">
            <div class="row-select" v-for="(item, index) in selectTopicFrom.optionList" :key="index">
              <div class="c-input">
                <v-text-field v-model="item.label" placeholder="请输入内容" outlined hide-details dense></v-text-field>
              </div>
              <div class="del-icon" @click="delSelect(index)">
                <span class="material-icons">delete_forever</span>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn elevation="0" :ripple="false" height="35" color="success"
            class="font-weight-normal text-capitalize btn-ls py-3 px-6" @click="selectDialogSubmit">确认</v-btn>
          <v-btn elevation="0" :ripple="false" height="35"
            class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
            @click="selectDialogClose">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
      },
      form: {},
      selectDialog: false,
      selectDialogTitle: "单选题",
      selectTopicFrom: {
        type: "radio", // radio单选 checkbox多选 question问答
        name: "",
        optionList:[]
      },
      selectTopicAddEdit: "add",
      selectTopicIndex: -1,

      checkbox: false,
      testpaperList: [
        {
          type: "radio",
          name: "我是一个单选题",
          isDown: false,
          isMust: false,
          option: [
            {
              value: 12,
              label: "选项1"
            },
            {
              value: 13,
              label: "选项2"
            },
          ]
        },
        {
          type: "checkbox",
          name: "我是一个多选题",
          isDown: false,
          isMust: false,
          option: [
            {
              value: 22,
              label: "选项1"
            },
            {
              value: 23,
              label: "选项2"
            },
            {
              value: 24,
              label: "选项3"
            },
          ]
        },
        {
          type: "question",
          name: "我是一个问答题",
          isDown: false,
          isMust: false,
          option: []
        },
      ],



    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  created() {

  },

  mounted() {
    
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'LearningAbilitySurvey',
      });
    },
    selectDialogOpen(type) {
      switch (type) {
        case "checkbox":
          this.selectDialogTitle = "多选题"
          this.selectTopicFrom.type = "checkbox"
          break;
        case "question":
          this.selectDialogTitle = "问答题"
          this.selectTopicFrom.type = "question"
          break;
        default:
          this.selectDialogTitle = "单选题"
          this.selectTopicFrom.type = "radio"
          break;
      }
      this.selectDialog = true
      this.selectTopicAddEdit == "add"
    },
    selectDialogClose() {
      this.selectDialog = false
      this.selectTopicFrom = {
        type: "radio",
        name: "",
        optionList:[]
      }
      this.selectTopicAddEdit = "add"
      this.selectTopicIndex = -1
    },
    addSelect() {
      this.selectTopicFrom.optionList.push({
        value: this.getTime(),
        label: ""
      })
    },
    delSelect(index) {
      this.selectTopicFrom.optionList.splice(index, 1)
    },
    selectDialogSubmit() {
      if (this.selectTopicAddEdit == "add") {

        this.testpaperList.push({
          type: this.selectTopicFrom.type,
          name: this.selectTopicFrom.name,
          option: this.selectTopicFrom.optionList,
        })
      } else {
        this.testpaperList[this.selectTopicIndex].type = this.selectTopicFrom.type
        this.testpaperList[this.selectTopicIndex].name = this.selectTopicFrom.name
        this.testpaperList[this.selectTopicIndex].option = this.selectTopicFrom.optionList
      }
      this.selectDialogClose()
    },


    editTestpaper(item,index) {
      this.selectDialog = true
      this.selectTopicAddEdit = "edit"
      this.selectTopicIndex = index
      this.selectTopicFrom.type = item.type
      this.selectTopicFrom.name = item.name
      this.selectTopicFrom.optionList = item.option
    },
    upTestpaper(index){
      let newArr = JSON.parse(JSON.stringify(this.testpaperList))
      this.swapArrayElements(newArr, index, index - 1)
      this.testpaperList = newArr
    },
    downTestpaper(index){
      let newArr = JSON.parse(JSON.stringify(this.testpaperList))
      this.swapArrayElements(newArr, index, index + 1)
      this.testpaperList = newArr
    },
    delTestpaper(index) {
      this.testpaperList.splice(index, 1)
    },

    // 获取当前时间戳作为id
    getTime() {
      let newTime = new Date().getTime();
      return newTime;
    },
    // 交换位置
    swapArrayElements(arr, A, B) {
      const temp = arr[A];
      arr[A] = arr[B];
      arr[B] = temp;
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  margin: 0 15px;

  .page-content {
    .ques-header {
      margin-bottom: 10px;
      .v-stepper {
        border-radius: 0;
      }
    }

    .ques-info {
      display: flex;
      .left-content {
        padding: 10px 20px;
        margin: 5px;
        text-align: center;
        border-radius: 3px;
        background-color: #9e9e9e;
        .select-title {
          font-size: 20px;
          font-weight: 900;
        }
        .select-btn {
          display: inline-block;
          .row {
            cursor: pointer;
            display: inline-block;
            padding: 10px 30px;
            margin: 10px 0;
            border-radius: 3px;
            background-color: #80ffff;
          }
        }
      }
      .right-content {
        flex: 1;
        padding: 5px 10px;
        margin: 5px;
        .form-flex {
          display: flex;
          margin: 5px 0;
          .form-header {
            margin-right: 10px;
          }
          .form-content {
            flex: 1;
          }
        }
        .test-paper {
          border: 1px solid #ccc;
          border-radius: 3px;
          padding: 15px;
          .paper-title {
            padding: 5px 0 10px;
            font-size: 18px;
          }
          .paper-content {
            .paper-row {
              border-top: 1px solid #f1f1f1;
              padding: 10px 0 5px 0;
              .first-operate {
                display: flex;
                margin-bottom: 10px;
                .big-title {
                  flex: 1;
                }
                .checkbox-title {
                  display: flex;
                  margin: 3px 15px 5px 0;
                  .v-input--selection-controls {
                    margin: 0;
                    padding: 0;
                  }
                }
                .icon {
                  display: flex;
                  .mdi {
                    font-size: 20px;
                    margin-right: 13px;
                    cursor: pointer;
                  }
                }
              }
              .second-title {
                margin-bottom: 10px;
              }
              .three-content {
                margin-bottom: 10px;
                .radio-select {

                }
                .checkbox-select {
                  
                }
                .quest-select {
                  border: 1px solid #ccc;
                  border-radius: 3px;
                  height: 100px;
                  color: #000061;
                  padding: 10px;
                  font-size: 14px;
                }
                .v-input--selection-controls {
                  margin: 5px 0;
                  padding: 0;
                }
              }
            }
          }
          .page-btn {
            border-top: 1px solid #f1f1f1;
            text-align: center;
            padding: 10px 0;
          }
        }
      }
    }
  }
}

.topic-form {
  .topic-title {
    display: flex;
    height: 20px;
    margin: 15px 0 10px 0;
    .idnex {
      display: inline-block;
      border: 1px solid #5662e6;
      margin-right: 5px;
      padding: 0 5px;
      border-radius: 3px;
      color: #3b63f2;
    }
    .icon {
      flex: 1;
      text-align: right;
      color: #3b63f2;
      cursor: pointer;
      .v-icon {
        font-size: 20px;
        color: #3b63f2;
        cursor: pointer;
      }
    }
  }
  .topic-select {
    .row-select {
      display: flex;
      margin: 10px 0;
      .c-input {
        flex: 1;
      }
      .del-icon {
        .material-icons {
          margin: 7px 5px 0 5px;
          cursor: pointer;
        }
      }
    }
    
  }
}
</style>